import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02d9dcf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full min-h-screen flex flex-col clear-both" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "text-md" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "flex flex-row mt-8" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xxl text-pxorange number-col font-bold" }, " 1 ", -1))
const _hoisted_8 = { class: "font-bold cursor-pointer flex-grow" }
const _hoisted_9 = { class: "flex flex-row mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xxl text-pxorange number-col font-bold" }, " 2 ", -1))
const _hoisted_11 = { class: "font-bold cursor-pointer flex-shrink-1" }
const _hoisted_12 = { class: "flex flex-row mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xxl text-pxorange number-col font-bold" }, " 3 ", -1))
const _hoisted_14 = { class: "font-bold cursor-pointer ml-0" }
const _hoisted_15 = { class: "lg:pl-16 flex-col items-center flex" }
const _hoisted_16 = {
  key: 0,
  src: "img/magnet_fridge.png",
  alt: "Magnets with fridge",
  class: ""
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "mt-4" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "bullets" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "mt-4" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "mt-4" }
const _hoisted_31 = ["innerHTML"]
const _hoisted_32 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReadMore = _resolveComponent("ReadMore")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ScreenWrapper, {
      next: _ctx.next,
      screen: _ctx.screen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              innerHTML: _ctx.$t('challenges.title'),
              class: "mb-8 font-space text-medium font-bold text-xl"
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              innerHTML: _ctx.$t('challenges.text1'),
              class: "mt-4 text-justify-no"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode(_toDisplayString(_ctx.$t('challenges.text2')) + " ", 1),
                _createElementVNode("span", {
                  class: "underline text-pxorange font-bold block",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleOption(1)))
                }, _toDisplayString(_ctx.$t('challenges.readMore')) + " »", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", _hoisted_11, [
                _createTextVNode(_toDisplayString(_ctx.$t('challenges.text3')) + " ", 1),
                _createElementVNode("span", {
                  class: "underline text-pxorange font-bold block",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleOption(2)))
                }, _toDisplayString(_ctx.$t('challenges.readMore')) + " »", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("p", _hoisted_14, [
                _createTextVNode(_toDisplayString(_ctx.$t('challenges.text4')) + " ", 1),
                _createElementVNode("span", {
                  class: "underline text-pxorange font-bold block",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleOption(3)))
                }, _toDisplayString(_ctx.$t('challenges.readMore')) + " »", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (!_ctx.option)
              ? (_openBlock(), _createElementBlock("img", _hoisted_16))
              : _createCommentVNode("", true),
            (_ctx.option === 1)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 1,
                  close: "",
                  onClosed: _ctx.closeCard,
                  "title-class": "text-left-important",
                  title: _ctx.$t('challenges.card1.title')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('challenges.card1.text1'),
                      class: "text-justify"
                    }, null, 8, _hoisted_17),
                    _createElementVNode("p", _hoisted_18, [
                      _createElementVNode("strong", {
                        innerHTML: _ctx.$t('challenges.solutions')
                      }, null, 8, _hoisted_19)
                    ]),
                    _createVNode(_component_ReadMore, {
                      onOpen: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$root.setupAndPlayIfOn(_ctx.FILES.audio_chal_mining1_details))),
                      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$root.stopAudio()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('challenges.card1.text2'),
                          class: "mb-4 mt-2"
                        }, null, 8, _hoisted_20),
                        _createElementVNode("ul", _hoisted_21, [
                          _createElementVNode("li", {
                            innerHTML: _ctx.$t('challenges.card1.bullet1')
                          }, null, 8, _hoisted_22),
                          _createElementVNode("li", {
                            innerHTML: _ctx.$t('challenges.card1.bullet2')
                          }, null, 8, _hoisted_23)
                        ]),
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('challenges.card1.text3'),
                          class: "mt-4 text-justify"
                        }, null, 8, _hoisted_24)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClosed", "title"]))
              : _createCommentVNode("", true),
            (_ctx.option === 2)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 2,
                  close: "",
                  onClosed: _ctx.closeCard,
                  "title-class": "text-left-important",
                  title: _ctx.$t('challenges.card2.title')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('challenges.card2.text1'),
                      class: "text-justify"
                    }, null, 8, _hoisted_25),
                    _createElementVNode("p", _hoisted_26, [
                      _createElementVNode("strong", {
                        innerHTML: _ctx.$t('challenges.solutions')
                      }, null, 8, _hoisted_27)
                    ]),
                    _createVNode(_component_ReadMore, {
                      onOpen: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$root.setupAndPlayIfOn(_ctx.FILES.audio_chal_recycling2_details))),
                      onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$root.stopAudio()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('challenges.card2.text2'),
                          class: "text-justify"
                        }, null, 8, _hoisted_28)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClosed", "title"]))
              : _createCommentVNode("", true),
            (_ctx.option === 3)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 3,
                  close: "",
                  onClosed: _ctx.closeCard,
                  "title-class": "text-left-important text-xl",
                  title: _ctx.$t('challenges.card3.title')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", {
                      innerHTML: _ctx.$t('challenges.card3.text1'),
                      class: "text-justify"
                    }, null, 8, _hoisted_29),
                    _createElementVNode("p", _hoisted_30, [
                      _createElementVNode("strong", {
                        innerHTML: _ctx.$t('challenges.solutions')
                      }, null, 8, _hoisted_31)
                    ]),
                    _createVNode(_component_ReadMore, {
                      onOpen: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$root.setupAndPlayIfOn(_ctx.FILES.audio_chal_demand3_details))),
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$root.stopAudio()))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", {
                          innerHTML: _ctx.$t('challenges.card3.text2'),
                          class: "text-justify"
                        }, null, 8, _hoisted_32)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClosed", "title"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ]))
}